export const initialState = {};
export const BannersReducer = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case 'BANNERS/SET_BANNERS':
            return payload;
        case 'BANNERS/ACK_BANNER':
            const { name, step } = payload;
            const steps = [...state[name].steps].filter((s) => s !== step);
            // Remove banner if no steps left
            if (steps.length === 0) {
                const { [name]: _, ...banners } = state;
                return banners;
            }
            // Remove step from banner if steps left
            const banner = { ...state[name], steps };
            const banners = { ...state, [name]: banner };
            return banners;
        default:
            return state;
    }
};
export default BannersReducer;
